import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardUserReportsOverviewRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-reports-overview',
	path: '/jira/people/:accountId/boards/:boardId/reports',
	query: ['dashboardId?'],
};
